import enJSON from '@/common/utilities/lang/en/home.js';
import esJSON from '@/common/utilities/lang/es/home.js';
import sellWelcome from '@/sell/components/sellwelcome/sell-welcome.vue';
import { mapGetters } from 'vuex';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import sellContent from '@/sell/components/sellcontent/sell-content.vue';
import mvtSnapshot from '@/common/components/mvtsnapshotnew/mvt-snapshot.vue';

export default {
    name: 'pageSell',
    inject: ['$eventBus'],
    components: {
        mvtPopSignin,
        mvtDialogCenter,
        sellWelcome,
        mvtHeader,
        mvtFooter,
        sellContent,
        mvtSnapshot,
    },
    data() {
        return {
            hotleadOpt: {
                hotleadTitle: `Sell Your Home with Local Real Estate Experts`,
                hotleadSub: 'Our Concierge Team Will Connect With You in 1-2 Minutes',
                hotleadType: 'ExpertConsultConsumerGlobalHomePageBottom',
                buttonText: 'Get Started',
                showAddress: true,
            },
        };
    },
    methods: {
        sendCashOffer() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtCashOffer',
                trigger: this.$options.name,
                opt: {
                    hotleadType: this.glb.geo && this.glb.geo.city ? 'LocalSellPageCashOffer' : 'SellPageCashOffer',
                },
            });
        },
        sendSellLead() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtSellLead',
                trigger: this.$options.name,
                opt: {
                    hotleadTitle: 'Message an Agent About Selling',
                    hotleadSub: null,
                    buttonText: this.molang('dpp.hotleadForm.go'),
                    hotleadType: this.glb.geo && this.glb.geo.city ? 'LocalSellPageSell' : 'ConnectWithSellerAgent',
                },
            });
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('sell', ['sell']),
        snapshotData() {
            let data = this.sell.snapshot && this.sell.snapshot.one_month_ago;
            if (
                data &&
                !(
                    data.singleTypeMedianListPrice > 0 ||
                    data.singleTypeMedianHouseSize > 0 ||
                    data.singleTypeMedianDom > 0 ||
                    data.singleTypeMedianPricePerSqftHouse > 0 ||
                    data.condoTypeMedianListPrice > 0 ||
                    data.condoTypeMedianHouseSize > 0 ||
                    data.condoTypeMedianDom > 0 ||
                    data.condoTypeMedianPricePerSqftHouse > 0 ||
                    data.allTypeMedianListPrice > 0 ||
                    data.allTypeMedianHouseSize > 0 ||
                    data.allTypeMedianDom > 0 ||
                    data.allTypeMedianPricePerSqftHouse > 0
                )
            ) {
                data = null;
            }
            return data || null;
        },
        sellCampaignHotleadType() {
            const qs = this.$route.query;
            if (qs) {
                if (qs.utm_campaign === 'homeowner' && qs.utm_source === 'sendgrid' && qs.utm_medium === 'email') {
                    return 'HomeownerSell_Digs';
                }
            }
            return null;
        },
        local() {
            return this.glb.geo && this.glb.geo.city ? `${this.glb.geo.city}, ${this.glb.geo.state}` : 'Local';
        },
    },
    mounted() {
        this.$eventBus.$emit('eventbus-pageLoaded');
        if (window.location.hash === '#howwework') {
            setTimeout(() => {
                document.getElementById('howwework').scrollIntoView();
            }, 1000);
        }
    },
    beforeCreate() {
        this.injectMolangDataStore({ type: 'home', en: enJSON, es: esJSON });
    },
};
